import { render } from "./Item8.vue?vue&type=template&id=57d3b1e6"
import script from "./Item8.vue?vue&type=script&lang=ts"
export * from "./Item8.vue?vue&type=script&lang=ts"
script.render = render

export default script